<script setup lang="ts">
import type { FormItem } from '@/entries/interact-form/types'
import { ANSWER_PREFIX_PATTERN } from '@/entries/interact-form/constants'

const props = defineProps<{
  question: FormItem
}>()

const emit = defineEmits<{
  'update:answer': [value: string[]]
}>()

/**
 * チェックボックスが選択されているか確認
 *
 * 特定の選択肢が現在選択されているかどうかを判定します
 *
 * @param {string} value - 確認する選択肢の値
 * @returns {boolean} 選択されている場合はtrue、そうでない場合はfalse
 */
function isChecked(value: string): boolean {
  if (!Array.isArray(props.question.answer)) {
    return false
  }
  return (props.question.answer as string[]).includes(value)
}

/**
 * チェックボックスの回答を設定
 *
 * ユーザーがチェックボックスを選択/解除したときに呼び出され、
 * 選択状態を切り替えて親コンポーネントに通知します
 *
 * @param {string} value - 選択/解除された選択肢の値
 */
function setCheckboxAnswer(value: string) {
  // 現在の回答を取得
  let answers: string[] = []
  if (Array.isArray(props.question.answer)) {
    answers = [...props.question.answer]
  }

  const index = answers.indexOf(value)

  if (index === -1) {
    // 選択されていなければ追加
    answers.push(value)
  } else {
    // 選択済みなら削除
    answers.splice(index, 1)
  }

  emit('update:answer', answers)
}
</script>

<template>
  <p>複数選択可</p>
  <div class="option-group">
    <div v-for="(option, index) in question.data" :key="index" class="option-item">
      <label class="checkbox-label">
        <input type="checkbox" :value="option" :checked="isChecked(option)"
          @change="setCheckboxAnswer(option)" />
        <span class="checkbox-text">{{ question.is_trigger ? option.replace(ANSWER_PREFIX_PATTERN,
          '') : option
          }}</span>
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.option-group {
  display: flex;
  flex-direction: column;
  border: 1px solid #a5dbdf;
  background-color: #fff;
}

.option-item {
  padding: 12px 16px;
  border-bottom: 1px solid #a5dbdf;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  & > input {
    width: 16px;
    height: 16px;
    margin: 0;
  }
}

.checkbox-text {
  margin-left: 10px;
}
</style>
